import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const API = process.env.REACT_APP_BACKEND_URL || '';

const GestionBienvenida = () => {
  const [bienvenida, setBienvenida] = useState({
    titulo: '',
    contenido: '',
    imagenes: []
  });
  const [seccionAdicional, setSeccionAdicional] = useState({
    titulo: '',
    contenido: '',
    imagenes: []
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [mensaje, setMensaje] = useState({ tipo: '', texto: '' });

  useEffect(() => {
    cargarDatos();
  }, []);

  const cargarDatos = async () => {
    try {
      const bienvenidaRes = await axios.get(`${API}/api/public/bienvenida`);
      setBienvenida(bienvenidaRes.data);
      
      const seccionRes = await axios.get(`${API}/api/public/seccion-adicional`);
      setSeccionAdicional(seccionRes.data);
    } catch (error) {
      console.error('Error cargando datos:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmitBienvenida = async (e) => {
    e.preventDefault();
    setSaving(true);
    setMensaje({ tipo: '', texto: '' });

    try {
      const token = localStorage.getItem('token');
      const formData = new FormData();
      formData.append('titulo', bienvenida.titulo);
      formData.append('contenido', bienvenida.contenido);
      formData.append('imagenes', JSON.stringify(bienvenida.imagenes));

      await axios.put(`${API}/api/admin/landing/bienvenida`, formData, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      setMensaje({ 
        tipo: 'success', 
        texto: '✅ Sección Bienvenida actualizada correctamente.' 
      });

      setTimeout(() => {
        cargarDatos();
        setMensaje({ tipo: '', texto: '' });
      }, 2000);

    } catch (error) {
      setMensaje({ 
        tipo: 'error', 
        texto: '❌ Error: ' + (error.response?.data?.detail || 'Error desconocido') 
      });
    } finally {
      setSaving(false);
    }
  };

  const handleSubmitSeccionAdicional = async (e) => {
    e.preventDefault();
    setSaving(true);
    setMensaje({ tipo: '', texto: '' });

    try {
      const token = localStorage.getItem('token');
      const formData = new FormData();
      formData.append('titulo', seccionAdicional.titulo);
      formData.append('contenido', seccionAdicional.contenido);
      formData.append('imagenes', JSON.stringify(seccionAdicional.imagenes));

      await axios.put(`${API}/api/admin/landing/seccion-adicional`, formData, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      setMensaje({ 
        tipo: 'success', 
        texto: '✅ Sección Adicional actualizada correctamente.' 
      });

      setTimeout(() => {
        cargarDatos();
        setMensaje({ tipo: '', texto: '' });
      }, 2000);

    } catch (error) {
      setMensaje({ 
        tipo: 'error', 
        texto: '❌ Error: ' + (error.response?.data?.detail || 'Error desconocido') 
      });
    } finally {
      setSaving(false);
    }
  };

  const agregarImagenBienvenida = () => {
    const url = prompt('Ingresa la URL de la imagen:');
    if (url && url.trim()) {
      setBienvenida({
        ...bienvenida,
        imagenes: [...bienvenida.imagenes, url.trim()]
      });
    }
  };

  const eliminarImagenBienvenida = (index) => {
    const nuevasImagenes = bienvenida.imagenes.filter((_, i) => i !== index);
    setBienvenida({
      ...bienvenida,
      imagenes: nuevasImagenes
    });
  };

  const agregarImagenSeccion = () => {
    const url = prompt('Ingresa la URL de la imagen:');
    if (url && url.trim()) {
      setSeccionAdicional({
        ...seccionAdicional,
        imagenes: [...seccionAdicional.imagenes, url.trim()]
      });
    }
  };

  const eliminarImagenSeccion = (index) => {
    const nuevasImagenes = seccionAdicional.imagenes.filter((_, i) => i !== index);
    setSeccionAdicional({
      ...seccionAdicional,
      imagenes: nuevasImagenes
    });
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <i className="fas fa-spinner fa-spin text-4xl text-blue-600"></i>
      </div>
    );
  }

  const renderEditor = (datos, setDatos, agregarImagen, eliminarImagen, onSubmit, titulo) => (
    <form onSubmit={onSubmit} className="space-y-6">
      {/* Título */}
      <div>
        <Label htmlFor={`titulo-${titulo}`} className="text-lg font-semibold text-gray-700">
          <i className="fas fa-heading mr-2 text-blue-600"></i>
          Título
        </Label>
        <Input
          id={`titulo-${titulo}`}
          value={datos.titulo}
          onChange={(e) => setDatos({ ...datos, titulo: e.target.value })}
          placeholder="Título de la sección"
          className="mt-2 text-lg"
          required
        />
      </div>

      {/* Contenido */}
      <div>
        <Label className="text-lg font-semibold text-gray-700">
          <i className="fas fa-align-left mr-2 text-blue-600"></i>
          Contenido
        </Label>
        <div className="mt-2">
          <ReactQuill
            theme="snow"
            value={datos.contenido}
            onChange={(value) => setDatos({ ...datos, contenido: value })}
            modules={{
              toolbar: [
                [{ 'header': [1, 2, 3, false] }],
                ['bold', 'italic', 'underline', 'strike'],
                [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                [{ 'color': [] }, { 'background': [] }],
                [{ 'align': [] }],
                ['link'],
                ['clean']
              ]
            }}
            formats={[
              'header',
              'bold', 'italic', 'underline', 'strike',
              'list', 'bullet',
              'color', 'background',
              'align',
              'link'
            ]}
            placeholder="Escribe el contenido aquí..."
            className="bg-white rounded-md"
            style={{ height: '300px', marginBottom: '50px' }}
          />
        </div>
        <p className="text-sm text-gray-500 mt-2">
          💡 Usa la barra de herramientas para dar formato: negritas, cursivas, colores, listas, etc.
        </p>
      </div>

      {/* Imágenes */}
      <div>
        <div className="flex items-center justify-between mb-3">
          <Label className="text-lg font-semibold text-gray-700">
            <i className="fas fa-images mr-2 text-blue-600"></i>
            Imágenes (URLs)
          </Label>
          <Button
            type="button"
            onClick={agregarImagen}
            className="bg-green-600 hover:bg-green-700"
          >
            <i className="fas fa-plus mr-2"></i>
            Agregar Imagen
          </Button>
        </div>

        {datos.imagenes.length === 0 ? (
          <div className="bg-gray-50 border-2 border-dashed border-gray-300 rounded-lg p-8 text-center text-gray-500">
            <i className="fas fa-image text-4xl mb-2"></i>
            <p>No hay imágenes agregadas</p>
          </div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
            {datos.imagenes.map((img, index) => (
              <div key={index} className="relative group">
                <img
                  src={img}
                  alt={`Imagen ${index + 1}`}
                  className="w-full h-32 object-cover rounded-lg shadow-md"
                  onError={(e) => {
                    e.target.src = 'https://via.placeholder.com/300x200?text=Error';
                  }}
                />
                <button
                  type="button"
                  onClick={() => eliminarImagen(index)}
                  className="absolute top-2 right-2 bg-red-600 text-white rounded-full p-2 opacity-0 group-hover:opacity-100 transition"
                >
                  <i className="fas fa-trash"></i>
                </button>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Botón Guardar */}
      <div className="flex justify-end pt-4 border-t">
        <Button
          type="submit"
          disabled={saving}
          className="bg-blue-600 hover:bg-blue-700 text-lg px-8 py-3"
        >
          {saving ? (
            <>
              <i className="fas fa-spinner fa-spin mr-2"></i>
              Guardando...
            </>
          ) : (
            <>
              <i className="fas fa-save mr-2"></i>
              Guardar Cambios
            </>
          )}
        </Button>
      </div>
    </form>
  );

  return (
    <div className="p-6 max-w-6xl mx-auto">
      <style>{`
        .ql-container {
          min-height: 300px;
          font-size: 16px;
        }
        .ql-editor {
          min-height: 300px;
          padding: 15px;
        }
        .ql-toolbar {
          border-radius: 8px 8px 0 0;
          background: #f8f9fa;
        }
        .ql-container {
          border-radius: 0 0 8px 8px;
        }
      `}</style>
      
      <Card className="shadow-xl">
        <CardHeader className="bg-gradient-to-r from-blue-600 to-purple-600 text-white">
          <CardTitle className="text-3xl flex items-center gap-3">
            <i className="fas fa-edit"></i>
            Gestión de Landing Page
          </CardTitle>
          <p className="text-blue-100 mt-2">
            Edita las secciones que verán los visitantes en la página principal
          </p>
        </CardHeader>

        <CardContent className="p-6">
          {/* Mensajes */}
          {mensaje.texto && (
            <div className={`mb-6 p-4 rounded-lg ${mensaje.tipo === 'success' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
              {mensaje.texto}
            </div>
          )}

          <Tabs defaultValue="bienvenida" className="w-full">
            <TabsList className="grid w-full grid-cols-2 mb-6">
              <TabsTrigger value="bienvenida" className="text-lg">
                <i className="fas fa-home mr-2"></i>
                Sección Bienvenida
              </TabsTrigger>
              <TabsTrigger value="adicional" className="text-lg">
                <i className="fas fa-info-circle mr-2"></i>
                Sección Adicional
              </TabsTrigger>
            </TabsList>

            <TabsContent value="bienvenida">
              {renderEditor(
                bienvenida,
                setBienvenida,
                agregarImagenBienvenida,
                eliminarImagenBienvenida,
                handleSubmitBienvenida,
                'bienvenida'
              )}
            </TabsContent>

            <TabsContent value="adicional">
              {renderEditor(
                seccionAdicional,
                setSeccionAdicional,
                agregarImagenSeccion,
                eliminarImagenSeccion,
                handleSubmitSeccionAdicional,
                'adicional'
              )}
            </TabsContent>
          </Tabs>
        </CardContent>
      </Card>
    </div>
  );
};

export default GestionBienvenida;
